<template>
  <transition name="fade">
    <div class="pattern-preview-modal" v-if="visible">

      <div class="pattern-preview-modal-holder" v-on-clickaway="hideModal">
        <div class="pattern-preview-modal-content">
          <div class="pattern-preview-ruler pattern-preview-ruler-width">
            <span>{{ $t('pattern.preview.size', {size: preview}) }} </span>
          </div>
          <div class="pattern-preview-ruler pattern-preview-ruler-height">
            <span>{{ $t('pattern.preview.size', {size: preview}) }} </span>
          </div>
          <div class="pattern-preview">
            <figure>
              <img :src="pattern.preview50cm" :class="[getPreview === 50?'block':'hidden']" class="block">
              <img :src="pattern.preview100cm" :class="[getPreview === 100?'block':'hidden']">
              <img :src="pattern.preview150cm" :class="[getPreview === 150?'block':'hidden']">
            </figure>
          </div>
          <div class="pattern-preview-scale">
            <span>{{ $t('pattern.preview.view') }}</span>
            <nav>
              <a href="#" @click="setPreview(50)"
                 :class="[getPreview === 50?'active':'']">{{ $t('pattern.preview.size', {size: 50}) }}</a>
              <a href="#" @click="setPreview(100)"
                 :class="[getPreview === 100?'active':'']">{{ $t('pattern.preview.size', {size: 100}) }}</a>
              <a href="#" @click="setPreview(150)"
                 :class="[getPreview === 150?'active':'']">{{ $t('pattern.preview.size', {size: 150}) }}</a>
            </nav>
          </div>

          <div class="pattern-preview-modal-close">
            <button @click="hideModal">&times;</button>
          </div>

          <div class="pattern-preview-information">
            <h1>
              {{ pattern.title ? pattern.title : $t('pattern.title.unkown') }}
            </h1>
            <h2>
              {{ $t('pattern.id', {id: pattern.id}) }}
            </h2>
            <address>
              <aside>
                <img :src="pattern.owner_avatar">
              </aside>
              <main>
                <span>{{ $t('pattern.designer') }}</span>
                <strong>{{ pattern.owner ? pattern.owner : '' }}</strong>
              </main>

            </address>
            <nav>
              <button @click="hideModal">
                <span> {{ $t('pattern.modal.close') }}</span>
              </button>
              <button v-if="!showSelect" @click="selectPattern">
                <span> {{ $t('pattern.modal.select') }}</span>
              </button>

            </nav>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import {directive as onClickaway} from 'vue-clickaway';

export default {
  directives: {
    onClickaway: onClickaway,
  },
  name: 'preview',
  data() {
    return {
      preview: {
        type: Number,
        default: 50
      }
    }
  },
  methods: {
    setPreview(data) {
      this.preview = data;
    },
    selectPattern() {
      this.$store.dispatch('setSelected', this.$store.getters.getPreview);
      this.hideModal();
    },
    hideModal() {
      if (this.visible) {
        this.preview = 50;
        this.$store.dispatch('hidePreview');
      }
    }
  },
  computed: {
    visible() {
      return this.$store.getters.showPreview;
    },
    pattern() {
      return this.$store.getters.getPreview;
    },
    getPreview() {
      return this.preview;
    },
    showSelect() {
      return (this.$parent.$props.hideSelect) ? true : false;
    }
  },
  mounted() {
    this.preview = 50;
  }
}
</script>

<style>


.pattern-picker.preview-close .pattern-preview-modal {
  @apply pointer-events-none;
  display: none;
}

.pattern-preview-modal {
  @apply overflow-hidden text-base fixed top-0 left-0 w-full h-full flex justify-center items-center bg-gray-400 z-50 bg-opacity-50
}

.pattern-preview-modal-content {
  @apply grid fixed  p-0 left-0 right-0 w-screen h-screen md:sticky lg:p-8  md:rounded relative bg-white  md:w-auto md:h-auto md:shadow-lg;
  grid-template-columns: 1fr;
  grid-template-rows: 100vw 20px 40px auto;
  grid-template-areas:
      "preview"
      "ruler-width"
      "pattern-scale"
      "info"
}

@screen sm {
  .pattern-preview-modal-content {
    grid-template-rows: auto 20px 40px auto;
  }

}

@screen landscape {
  .pattern-preview-modal-content {
    grid-template-columns: 100vh auto;
    grid-template-rows: auto;
    grid-template-areas:
      "preview info"

  }

  .pattern-preview-ruler-width {
    display: none !important;
  }

  .pattern-preview-scale {
    display: none !important;
  }
}

@screen lg {
  .pattern-preview-modal-content {
    grid-template-columns: 20px var(--pattern-preview) var(--pattern-preview);
    grid-template-rows: 20px var(--pattern-preview) 40px;
    gap: 8px;
    grid-template-areas:
    ". ruler-width close"
    "ruler-height preview info"
    ". pattern-scale .";
  }
}

.pattern-preview-ruler {
  @apply relative flex w-full overflow-hidden items-center justify-center;
}

.pattern-preview-ruler:before {
  @apply absolute block h-0.5  w-full bg-gray-100 z-10;
  content: " ";
}

.pattern-preview-ruler span {
  @apply px-16 block text-center bg-white z-20 whitespace-nowrap text-gray-700 text-base;
}

.pattern-preview-ruler-width {
  grid-area: ruler-width;
  @apply flex lg:flex landscape:hidden;
}

.pattern-preview-ruler-height {
  @apply hidden lg:flex landscape:hidden;
  grid-area: ruler-height;
}

.pattern-preview-ruler-height:before {
  @apply w-0.5 h-full;
}

.pattern-preview-ruler-height span {
  transform: rotate(270deg);
}

.pattern-preview {
  @apply z-30;
  grid-area: preview;
}

.pattern-preview figure {
  @apply bg-gray-300 md:rounded overflow-hidden;
}

.pattern-preview-scale {
  grid-area: pattern-scale;
  @apply flex lg:flex flex-row items-center justify-start px-4 lg:px-0 relative landscape:hidden landscape:invisible;
}

.pattern-preview-scale span {
  @apply text-gray-700 mr-2 text-base hidden md:flex;
}

.pattern-preview-scale nav {
  @apply rounded flex flex-row text-primary overflow-hidden items-center justify-center;
}

.pattern-preview-scale nav a {
  @apply px-2.5 py-1 text-primary no-underline border border-primary border-solid border focus:border-opacity-0 whitespace-nowrap  text-base;
}

.pattern-preview-scale nav a:first-child {
  @apply border-r-0 rounded-l;
}

.pattern-preview-scale nav a:last-child {
  @apply border-l-0 rounded-r;
}

.pattern-preview-scale nav a.active {
  @apply px-2 py-1 bg-primary text-white;
}

.pattern-preview-modal-close {
  grid-area: close;
  @apply absolute z-50 top-1 right-1 shadow lg:shadow-none bg-white bg-opacity-70 rounded-full lg:rounded-none w-10 h-10 lg:w-auto lg:h-auto lg:bg-transparent lg:relative flex items-center  justify-center lg:justify-end;
}

.pattern-preview-modal-close button {
  @apply text-xl font-medium border-0 outline-none;
}

.pattern-preview-information {
  @apply flex flex-col justify-start md:justify-center lg:mx-0 lg:my-auto p-4 sm:p-8 font-normal text-gray-700 overflow-hidden overflow-ellipsis leading-tight;
  grid-area: info;
}

.pattern-preview-information h1 {
  @apply font-normal text-gray-700 flex-shrink-0  leading-tight  text-xl md:text-2xl;
}

.pattern-preview-information h2 {
  @apply font-light text-gray-600 flex-shrink-0 truncate overflow-hidden  text-base md:text-xl overflow-ellipsis leading-tight;
}

.pattern-preview-information address {
  @apply not-italic flex flex-row my-5 text-base items-center justify-start ;
}

.pattern-preview-information address aside {
  @apply hidden md:flex flex-shrink-0 flex-grow-0 mr-2 text-gray-300;
}

.pattern-preview-information address aside img {
  @apply rounded-full h-16 w-16 object-cover object-center;
}

.pattern-preview-information address main {
  @apply block truncate overflow-ellipsis;
  min-width: 0;
  box-sizing: border-box;
}

.pattern-preview-information address main span {
  @apply pr-8 sm:pr-0 sm:block text-gray-500 font-light whitespace-nowrap overflow-hidden overflow-ellipsis;
}

.pattern-preview-information address main strong {
  @apply text-gray-700 font-normal whitespace-nowrap overflow-hidden overflow-ellipsis truncate;
}

.pattern-preview-information nav {
  @apply flex flex-row items-center justify-start
}

.pattern-preview-information nav button {
  @apply outline-none leading-none mt-4 text-base text-primary rounded shadow mr-2.5 px-3 py-2.5 rounded border border-primary border-solid
}

.pattern-preview-information nav button:last-child {
  @apply text-white bg-primary;
}

</style>